import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { SelectOption } from "shared/types/Select"
import { BuildingType } from "shared/types/references/BuildingType"
import { RoomType } from "shared/types/references/RoomType"
import { IconName } from "shared/ui/icon/__generated__/IconName"

export enum ReferenceFilterType {
  PRODUCT = "product",
  BUILDING_TYPE = "building-type",
  ROOM_TYPE = "room-type"
}

export interface ReferenceProductFilterItem extends SelectOption<string> {
  key: string
  productObj?: ProductObj
  filterType: ReferenceFilterType.PRODUCT
}

export interface ReferenceBuildingTypeFilterItem
  extends SelectOption<BuildingType> {
  key: string
  icon?: IconName
  filterType: ReferenceFilterType.BUILDING_TYPE
}

export interface ReferenceRoomTypeFilterItem extends SelectOption<RoomType> {
  key: string
  filterType: ReferenceFilterType.ROOM_TYPE
}

export type ReferenceFilterItem =
  | ReferenceProductFilterItem
  | ReferenceBuildingTypeFilterItem
  | ReferenceRoomTypeFilterItem
